import { render, staticRenderFns } from "./SoftwareLicense.vue?vue&type=template&id=6cef9750&scoped=true&"
import script from "./SoftwareLicense.vue?vue&type=script&lang=js&"
export * from "./SoftwareLicense.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareLicense.vue?vue&type=style&index=0&id=6cef9750&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cef9750",
  null
  
)

export default component.exports